<template>
  <div class="bm-setting-player" >
    <div class="title" >
      队员身份验证资料
    </div>
    <div class="main" >
      <van-row gutter="5">
        <van-col span="8">
          <div class="btn active" >姓名</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.playerNumberRequired.default}" @click="toggleStyleActive('playerNumberRequired')" >球衣号码</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.contactNumberRequired.default}" @click="toggleStyleActive('contactNumberRequired')" >联系电话</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.facePhotoRequired.default}" @click="toggleStyleActive('facePhotoRequired')" >头像</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.genderRequired.default}" @click="toggleStyleActive('genderRequired')" >性别</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.birthdayRequired.default}" @click="toggleStyleActive('birthdayRequired')" >出生日期</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.heightRequired.default}" @click="toggleStyleActive('heightRequired')" >身高</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.weightRequired.default}" @click="toggleStyleActive('weightRequired')" >体重</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.positionRequired.default}" @click="toggleStyleActive('positionRequired')" >场上位置</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.eMailRequired.default}" @click="toggleStyleActive('eMailRequired')" >邮箱</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.idCardNumberRequired.default}" @click="toggleStyleActive('idCardNumberRequired')" >身份证号</div>
        </van-col>
        <van-col span="8">
          <div class="btn" :class="{active: this.signupFields.idCardPhotoRequired.default}" @click="toggleStyleActive('idCardPhotoRequired')" >身份证正反照</div>
        </van-col>
      </van-row>
    </div>
    <div class="footer" >
      <van-button type="primary" size="large" @click="setMatchRule" >确认</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Row, Col, Toast } from 'vant'
import { getBMMatchSignUpRule, updateBMMatchSignUpRule } from '@/api/team'
Vue.use(Row).use(Col)
const setting = {
  trueNameRequired: {
    value: 'bmTrueName',
    default: true
  },
  eMailRequired: {
    value: 'bmEmail',
    default: false
  },
  facePhotoRequired: {
    value: 'isPhotoPass',
    default: false
  },
  idCardNumberRequired: {
    value: 'IDCardNumber',
    default: false
  },
  contactNumberRequired: {
    value: 'contactNumber',
    default: false
  },
  idCardPhotoRequired: {
    value: 'isIDCardPhotoPass',
    default: false
  },
  weightRequired: {
    value: 'weight',
    default: false
  },
  heightRequired: {
    value: 'high',
    default: false
  },
  birthdayRequired: {
    value: 'bmBirthday',
    default: false
  },
  genderRequired: {
    value: 'gender',
    default: false
  },
  playerNumberRequired: {
    value: 'number',
    default: false
  },
  positionRequired: {
    value: 'position',
    default: false
  }
}
export default {
  name: 'SettingPlayer',
  data() {
    return {
      query: this.$route.query,
      matchId: null,
      signupFields: setting,
      getSignupFields: []
    }
  },
  created() {
    this.matchId = this.query.matchId
    if (!this.matchId) {
      Toast('参数错误')
      return
    }
    this.getBMMatchSignUpRule()
  },
  computed: {},
  methods: {
    getBMMatchSignUpRule() {
      getBMMatchSignUpRule({ matchId: this.matchId }).then((response) => {
        this.getSignupFields = response.data.signUpRule.signupFields.split(',')
        for (let obj in this.signupFields) {
          this.getSignupFields.forEach((item) => {
            // api缺少场上位置所以暂未做处理
            if (this.signupFields[obj].value === item) {
              this.signupFields[obj].default = true
            }
          })
        }
      })
    },
    setMatchRule() {
      let params = {}
      for (let item in this.signupFields) {
        params[item] = this.signupFields[item].default ? 1 : 0
      }
      params.matchId = this.matchId
      params.trueNameRequired = 1
      updateBMMatchSignUpRule(params).then((response) => {
        if (response) {
          Toast('更新成功')
          this.$router.go(-1)
        }
      })
    },
    toggleStyleActive(obj) {
      this.signupFields[obj].default = !this.signupFields[obj].default
    }
  }
}
</script>

<style lang="stylus" >
.bm-setting-player
  background-color: white
  width 100%
  height: 100%
  position absolute
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  .main
    padding: 0 15px
    .van-row
      .van-col
        height: 50px
        text-align center
        line-height 50px
        margin-bottom: 5px
        .btn
          width: 100%
          height: 100%
          border-radius 2px
          font-size: 14px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          color: #818181
          border:1px solid rgba(248,248,248,1);
          background white
        .active
          background-color #32A377
          color:rgba(255,255,255,1);
  .footer
    position absolute
    bottom 15px
    left 50%
    transform translate(-50%, 0)
    padding: 0 40px
    width: calc(100% - 80px)
    .van-button
      border none
      font-size:16px;
      font-weight normal
      color:rgba(50,163,119,1);
      line-height:25px;
      border-radius 4px
    .van-button--primary
      background-color #32A377
      font-size:16px;
      font-weight:400;
      color:rgba(255,255,255,1);

</style>



// WEBPACK FOOTER //
// src/pages/team/setting/player/info.vue